// 7 ليالي بيننا — content data (programs + cards + scripts + bonus).
// Pure data file used across landing/dashboard/program/cards/scripts pages.

export const BUNDLES = [
  {
    key: "starter",
    label: "نسخة البداية",
    price: 99,
    price_original: 149,
    tagline: "للعرسان أو الأزواج الذين يريدون تجربة خفيفة",
    items: [
      "برنامج 7 ليالي للعرسان",
      "70 بطاقة رقمية مختارة",
      "رسائل واتساب جاهزة",
    ],
  },
  {
    key: "reset",
    label: "نسخة الرجوع",
    price: 149,
    price_original: 229,
    tagline: "للأزواج بعد الروتين أو بعد الأطفال",
    items: [
      "برنامج 7 ليالي بعد الروتين",
      "100 بطاقة رقمية مختارة",
      "خطة بدون جوالات",
      "رسائل واتساب جاهزة",
    ],
  },
  {
    key: "complete",
    label: "النسخة الكاملة",
    price: 199,
    price_original: 299,
    tagline: "الأفضل قيمة — كل البرامج والبطاقات والرسائل",
    highlight: true,
    items: [
      "برنامج العرسان",
      "برنامج بعد الروتين",
      "150 بطاقة رقمية",
      "30 رسالة دلع",
      "10 أفكار ليالي بيتية",
      "خطة شهرية للاستمرار",
    ],
  },
];

// Access — what each bundle unlocks
export const ACCESS = {
  starter:  { newlyweds: true,  routine: false, cards: 70,  scripts: true,  noPhonePlan: false, bonus: false },
  reset:    { newlyweds: false, routine: true,  cards: 100, scripts: true,  noPhonePlan: true,  bonus: false },
  complete: { newlyweds: true,  routine: true,  cards: 150, scripts: true,  noPhonePlan: true,  bonus: true  },
};

// PROGRAM 1 — أول 7 ليالي للعرسان
export const NEWLYWEDS = {
  title: "أول 7 ليالي للعرسان",
  intro:
    "هذه الخطة ليست لتعليمكم كيف تحبون بعض. هي فقط تساعدكم تبدأون القرب بطريقة مريحة، بدون ضغط، وبدون أسئلة محرجة. الهدف أن كل ليلة تفتح بابًا صغيرًا بينكم.",
  rules: [
    "لا جوالات أثناء الليلة",
    "لا تحقيق ولا لوم",
    "لا تقارنون أنفسكم بغيركم",
    "كل إجابة قصيرة تكفي",
    "إذا سؤال لم يناسبكم، تجاوزوه",
    "المهم الهدوء وليس المثالية",
  ],
  nights: [
    {
      n: 1, title: "ليلة نكسر الرسميات",
      goal: "تخفيف التوتر وبناء راحة أولية.",
      setup: "جلسة بسيطة في البيت. مشروب تحبونه. إضاءة هادئة. الجوال بعيد.",
      startLine: "«خلينا الليلة نسوي شيء بسيط… نعرف بعض بعيد عن الرسميات.»",
      questions: [
        "ما أول شيء لاحظته فيني؟",
        "متى حسيت إنك ارتحت لي؟",
        "وش أكثر شيء كان مخوفك قبل الزواج؟",
        "وش الشيء الذي تتمنى أتعلمه عنك بسرعة؟",
        "وش الشيء الذي يخليك تحس بالأمان؟",
      ],
      activity: "كل شخص يقول ثلاث أشياء أعجبته في الطرف الثاني منذ بداية العلاقة.",
      challenge: "امسكوا يد بعض لمدة دقيقة بدون كلام.",
      closing: "«أبغى بيننا يكون فيه راحة قبل أي شيء.»",
    },
    {
      n: 2, title: "ليلة الذكريات الأولى",
      goal: "خلق دفء وحنين.",
      setup: "افتحوا صورة أو ذكرى من بداية العلاقة.",
      questions: [
        "ما أجمل لحظة تتذكرها من بدايتنا؟",
        "ما الشيء الذي ابتسمت بسببه لكن ما قلته وقتها؟",
        "ما أكثر موقف حسسك أن العلاقة حقيقية؟",
        "ما أول شيء حبيته في شخصيتي؟",
        "ما ذكرى تريد نعيدها بطريقة جديدة؟",
      ],
      activity: "اختاروا ذكرى واحدة واكتبوا كيف يمكن إعادة نسختها الجديدة خلال شهر.",
      challenge: "كل شخص يرسل للآخر رسالة قصيرة وهو جالس أمامه.",
      closing: "«أكثر شيء أحببته في بدايتنا هو ____، وأبغى هذا الشيء ما يختفي بيننا.»",
    },
    {
      n: 3, title: "ليلة اللي يريحني",
      goal: "فهم الاحتياجات الصغيرة.",
      questions: [
        "ما التصرف البسيط الذي يريحك مني؟",
        "متى تحس أني قريب منك فعلًا؟",
        "ما الشيء الذي لو فعلته أكثر سيغير يومك؟",
        "كيف تحب أواسيك وقت التعب؟",
        "ما الشيء الذي يزعلك لكن قد لا تقوله؟",
      ],
      activity: "كل شخص يختار عادة صغيرة يلتزم بها أسبوعًا.",
      examples: ["رسالة صباحية", "حضن عند الرجوع للبيت", "سؤال يومي بدون جوال", "كوب قهوة/شاي", "كلمة تقدير"],
    },
    {
      n: 4, title: "ليلة الدلع الخفيف",
      goal: "إدخال playful romance بدون إحراج.",
      questions: [
        "ما نوع الدلع الذي تحبه؟",
        "ما الكلمة التي تحب تسمعها مني؟",
        "ما الشيء الذي يخليك تبتسم حتى لو كنت متعبًا؟",
        "ما أكثر تصرف بسيط يلفت انتباهك؟",
        "ما لحظة تحب أكررها؟",
      ],
      activity: "كل شخص يختار لقبًا لطيفًا للطرف الثاني يستخدمه لمدة يوم.",
      challenge: "قولوا لبعض جملة رومانسية بدون ضحك أو تهرب.",
    },
    {
      n: 5, title: "ليلة بدون أقنعة",
      goal: "فتح مساحة صدق لطيفة.",
      questions: [
        "ما الشيء الذي تخاف أن أسيء فهمه عنك؟",
        "متى تحتاج مساحة؟",
        "متى تحتاج قرب؟",
        "ما طريقتك في التعبير عن الحب؟",
        "ما طريقتك في استقبال الحب؟",
      ],
      activity: "اكتبوا جملة: «أحس بحبك أكثر عندما ____».",
    },
    {
      n: 6, title: "ليلة جرأة بذوق",
      goal: "إضافة خصوصية زوجية راقية بدون فجاجة.",
      note: "هذه الليلة اختيارية. الهدف ليس الإحراج، بل زيادة الراحة والدلع بين الزوجين.",
      questions: [
        "ما الشيء الرومانسي الذي تحب أن يحدث أكثر بيننا؟",
        "ما الجو الذي يجعلك أقرب لي؟",
        "ما أكثر طريقة تعبير تحبها: كلام، لمس، وقت، اهتمام، مفاجأة؟",
        "ما الشيء الذي يخليك تحس أنك مرغوب؟",
        "ما حدود الراحة التي تحب نحترمها دائمًا؟",
      ],
      activity: "كل شخص يختار بطاقة من «بطاقات القرب» وينفذها إذا كان الطرفان مرتاحين.",
      examples: [
        "اجلسوا قريبين لمدة خمس دقائق بدون جوال",
        "قولوا جملة إعجاب صريحة",
        "اختاروا أغنية تصبح مرتبطة بهذه الليلة",
        "حضن طويل بدون استعجال",
        "اكتبوا رسالة خاصة لا يراها أحد",
      ],
    },
    {
      n: 7, title: "ليلة اتفاقنا الجديد",
      goal: "تحويل التجربة إلى عادة.",
      questions: [
        "ما أكثر ليلة أحببتها؟",
        "ما الشيء الذي اكتشفته عني؟",
        "ما الشيء الذي تريد يستمر؟",
        "ما العادة التي نقدر نسويها أسبوعيًا؟",
        "ما وعد بسيط نلتزم به؟",
      ],
      activity: "اتفاق أسبوعي: «كل أسبوع لنا ساعة بدون جوالات، بدون طلبات، بدون مسؤوليات.»",
      closing: "كل شخص يقول: «الشيء الذي أريد أحافظ عليه بيننا هو ____.»",
    },
  ],
};

// PROGRAM 2 — 7 ليالي بعد الروتين
export const ROUTINE = {
  title: "7 ليالي بعد الروتين",
  intro:
    "هذه الخطة للأزواج الذين يحبون بعض لكن الروتين غطى على القرب. ليست لإصلاح كل شيء في ليلة. هي لإعادة بداية صغيرة: كلام، ضحك، اهتمام، ولمسة دفء.",
  rules: [
    "لا فتح ملفات قديمة في أول ليلتين",
    "لا لوم",
    "لا اختبار للطرف الآخر",
    "لا تنتظر تغيرًا كاملًا فورًا",
    "كل ليلة 30 إلى 60 دقيقة فقط",
    "الجوال بعيد",
  ],
  nights: [
    {
      n: 1, title: "ليلة نرجع نضحك",
      goal: "إزالة ثقل الروتين.",
      startLine: "«خلينا الليلة ما نناقش مسؤوليات. أبغى نضحك شوي ونرجع خفاف.»",
      questions: [
        "ما أغرب موقف صار بيننا وتضحك عليه الآن؟",
        "ما عادة فيني تضحكك سرًا؟",
        "لو نسافر يومين فقط، أين تود نروح؟",
        "ما أكلة أو مكان يذكرك ببدايتنا؟",
        "ما الشيء الذي كان بيننا زمان وتفتقده؟",
      ],
      activity: "كل شخص يختار ذكرى مضحكة ويعيد حكايتها.",
      challenge: "خذوا صورة عادية لكم في البيت كأنها ذكرى سفر.",
    },
    {
      n: 2, title: "ليلة مو كل شيء مسؤوليات",
      goal: "استعادة الهوية كزوج وزوجة، لا فقط كأب وأم.",
      questions: [
        "متى آخر مرة حسيت أننا زوجان لا فقط ندير البيت؟",
        "ما الشيء الذي سرق وقتنا أكثر؟",
        "ما الشيء البسيط الذي نقدر نرجعه؟",
        "ما الوقت المناسب لنا أسبوعيًا؟",
        "ما النشاط الذي لا يحتاج خروج لكنه يغير الجو؟",
      ],
      activity: "اختاروا «ساعة زوجية» ثابتة أسبوعيًا.",
      closing: "لا أطفال، لا طلبات، لا ميزانية، لا جوالات.",
    },
    {
      n: 3, title: "ليلة اللي بخاطري",
      goal: "التعبير بدون هجوم.",
      questions: [
        "ما الشيء الذي تفتقده بيننا؟",
        "ما الشيء الذي أفعله ويشعرك أني ما زلت مهتمًا؟",
        "ما الشيء الذي يجعلك تنسحب؟",
        "ما الشيء الذي تحتاجه مني وقت الضغط؟",
        "ما الشيء الذي تحب أن ألاحظه أكثر؟",
      ],
      activity: "كل شخص يقول طلبًا واحدًا فقط. لا قائمة طلبات.",
      examples: ["مثال: «أبغى 10 دقائق معك آخر اليوم بدون جوال.»"],
    },
    {
      n: 4, title: "ليلة التقدير",
      goal: "إعادة رؤية مجهود الطرف الآخر.",
      questions: [
        "ما الشيء الذي أفعلُه وتعرف أنه يتعبني؟",
        "ما الشيء الذي لم تشكرني عليه منذ فترة؟",
        "ما الصفة التي تحترمها فيني؟",
        "متى شعرت أني وقفت معك؟",
        "ما الشيء الذي تريد أسمعه منك أكثر؟",
      ],
      activity: "كل شخص يقول: «أعرف أنك تتعب في ____، وأنا أقدّر هذا.»",
      challenge: "اكتبوا رسالة تقدير تحفظ في الجوال.",
    },
    {
      n: 5, title: "ليلة نرجع نهتم",
      goal: "تحويل الاهتمام إلى أفعال صغيرة.",
      questions: [
        "ما أكثر شيء بسيط يغير مزاجك؟",
        "ما طريقتك المفضلة للاهتمام؟",
        "ما الشيء الذي كنت أفعله في البداية وتفتقده؟",
        "ما عادة نقدر نرجعها؟",
        "ما المفاجأة الصغيرة التي تحبها؟",
      ],
      activity: "اختاروا 3 أفعال اهتمام للأسبوع.",
      examples: ["رسالة وسط اليوم", "قهوة/حلى", "مشوار قصير", "سؤال قبل النوم", "مجاملة صريحة", "جلسة بدون جوال"],
    },
    {
      n: 6, title: "ليلة قرب خاص",
      goal: "إرجاع الإحساس بالاختيار والرغبة والقرب.",
      note: "هذه الليلة للزوجين فقط وبطريقة راقية. كل شيء اختياري وبالاتفاق.",
      questions: [
        "ما الجو الذي يخليك تحس بالقرب؟",
        "ما الشيء الذي يخليك تشعر أنك مرغوب؟",
        "ما أكثر تعبير رومانسي تحبه؟",
        "ما الشيء الذي يقطع القرب بيننا؟",
        "ما الشيء الذي نقدر نغيره في أجواء البيت؟",
      ],
      activity: "جهزوا «ركن ليلة خاصة»: إضاءة، عطر، مشروب، موسيقى هادئة، جوال بعيد.",
      examples: [
        "مجاملة صريحة",
        "حضن طويل",
        "جلوس قريب",
        "رسالة خاصة",
        "اختيار ذكرى رومانسية",
        "اتفاق على ليلة شهرية خاصة",
      ],
    },
    {
      n: 7, title: "ليلة لا نرجع مثل قبل",
      goal: "تثبيت عادة تمنع عودة البرود.",
      questions: [
        "ما أكثر شيء فرق معك هذا الأسبوع؟",
        "ما الليلة التي تريد نكررها؟",
        "ما العادة التي سنثبتها؟",
        "ما الشيء الذي يجب نحميه من الروتين؟",
        "ما وعد بسيط نبدأ به؟",
      ],
      activity: "اكتبوا اتفاق الزوجين: ساعة أسبوعية، ليلة شهرية، رسالة تقدير، لا نوم بعد زعل كبير، لا تحويل كل جلسة لمسؤوليات.",
      closing: "«ما نحتاج نكون مثاليين. نحتاج فقط ما نترك الأيام تأخذنا من بعض.»",
    },
  ],
};

// CARDS — 150 cards across 10 categories
export const CARD_CATEGORIES = [
  {
    key: "icebreaker",
    label: "كسر الجليد",
    items: [
      "ما أول شيء لفتك فيني؟",
      "ما عادة عندي تضحكك؟",
      "لو نرجع لأول لقاء، ماذا ستقول لي؟",
      "ما أكثر أكلة تذكرنا ببعض؟",
      "ما الشيء الذي تتمنى نسويه بدون تخطيط؟",
      "من فينا أكثر رومانسية؟",
      "من فينا يزعل بسرعة؟",
      "من فينا يحتاج دلال أكثر؟",
      "ما أكثر كلمة أقولها كثيرًا؟",
      "ما الشيء الذي تغير فينا للأفضل؟",
      "لو عندنا يوم كامل بدون مسؤوليات، كيف نقضيه؟",
      "ما ذكرى صغيرة لا تزال في بالك؟",
      "ما أكثر موقف حسيت فيه أننا فريق؟",
      "ما الشيء الذي لا يعرفه الناس عن علاقتنا؟",
      "ما أكثر شيء بسيط تحبه في البيت؟",
    ],
  },
  {
    key: "rediscover",
    label: "أعرفك من جديد",
    items: [
      "ما أكثر شيء يريحك؟",
      "ما الشيء الذي يضغطك ولا تقوله؟",
      "كيف أعرف أنك متعب؟",
      "ما أكثر شيء تحتاجه وقت الزعل؟",
      "ما طريقة الاعتذار التي تريحك؟",
      "ما الشيء الذي يجعلك تحس أنك مسموع؟",
      "ما أكثر كلمة تؤثر فيك؟",
      "ما الشيء الذي تخاف أن أسيء فهمه؟",
      "متى تحتاج مساحة؟",
      "متى تحتاج قرب؟",
      "ما أكثر شيء تفتقده من بدايتنا؟",
      "ما الصفة التي تحب أن أراها فيك؟",
      "ما الشيء الذي تريدني أقدره أكثر؟",
      "ما الشيء الذي تتمنى نتعلمه معًا؟",
      "ما الجانب الذي تغير فيك بعد الزواج؟",
    ],
  },
  {
    key: "feelings",
    label: "اللي بخاطري",
    items: [
      "أفتقد بيننا ____.",
      "أحب عندما تفعل ____.",
      "أحتاج منك أكثر ____.",
      "يريحني عندما تقول ____.",
      "يزعلني لكن لا أقوله دائمًا ____.",
      "أحس بالقرب منك عندما ____.",
      "أتمنى أن نرجع ____.",
      "أكثر شيء أقدره فيك ____.",
      "أحتاج أن تسمعني أكثر في ____.",
      "أريد أن أكون أوضح معك في ____.",
      "الشيء الذي أخاف عليه بيننا هو ____.",
      "الشيء الذي لا أريد أن نخسره هو ____.",
      "أحب أن تعاملني وقت التعب بـ ____.",
      "أريد أن أتعلم كيف أحبك بطريقة تناسبك.",
      "أكثر لحظة أحتاجك فيها هي ____.",
    ],
  },
  {
    key: "affection",
    label: "دلع واهتمام",
    items: [
      "قل للطرف الثاني صفة تحبها في شكله.",
      "قل جملة رومانسية بدون مزاح.",
      "اختر لقبًا لطيفًا للطرف الثاني.",
      "اكتب رسالة قصيرة وأرسلها الآن.",
      "قل: «أحب وجودك في حياتي لأن ____.»",
      "امدح شيئًا لم تمدحه منذ فترة.",
      "اسأل: «وش الشيء الذي يدلعك فعلًا؟»",
      "شارك أغنية تذكركم ببعض.",
      "اذكر موقفًا جعلك تحترم الطرف الثاني.",
      "قل شيئًا تفتقده من بدايتكم.",
      "اختاروا عادة اهتمام يومية.",
      "اتفقوا على كلمة سر تعني: أحتاج قربك.",
      "قولوا لبعض: «أنا ممتن لك بسبب ____.»",
      "اختاروا مشروبًا يصبح مشروب ليلتكم.",
      "اكتبوا وعدًا صغيرًا للأسبوع.",
    ],
  },
  {
    key: "after_kids",
    label: "بعد الأطفال والروتين",
    items: [
      "ما أكثر شيء أخذنا من بعض بعد الأطفال؟",
      "كيف نرجع ساعة لنا فقط؟",
      "ما المسؤولية التي تتمنى ألاحظها أكثر؟",
      "ما أكثر وقت تحتاج فيه دعم؟",
      "كيف نكون زوجين لا فقط أبوين؟",
      "ما الشيء الذي نقدر نخففه من ضغط البيت؟",
      "ما عادة صغيرة نقدر نحميها؟",
      "ما الشيء الذي يجعلك تشعر أني بجانبك؟",
      "متى تحس أني بعيد؟",
      "كيف نرجع الضحك في البيت؟",
      "ما أكثر شيء تحتاجه نهاية اليوم؟",
      "ما الشيء الذي تريد نوقف نؤجله؟",
      "ما النشاط البيتي الذي نقدر نسويه أسبوعيًا؟",
      "كيف نخفف الجوال بيننا؟",
      "ما معنى «وقت خاص» بالنسبة لك؟",
    ],
  },
  {
    key: "intimate",
    label: "جرأة بذوق",
    items: [
      "ما الجو الذي يجعلك أكثر قربًا؟",
      "ما نوع الكلام الرومانسي الذي تحبه؟",
      "ما اللمسة البسيطة التي تريحك؟",
      "ما الشيء الذي يخليك تحس أنك مرغوب؟",
      "ما أكثر تصرف يجذبك في الطرف الآخر؟",
      "ما الرائحة أو الإضاءة التي تحبها؟",
      "ما أكثر لحظة رومانسية تتذكرها؟",
      "ما الشيء الذي تريد تكراره بيننا؟",
      "ما الشيء الذي يزيد راحتك؟",
      "ما الحدود التي تحب نحترمها؟",
      "كيف تحب أن تبدأ ليلة خاصة؟",
      "ما الشيء الذي يقطع الجو بيننا؟",
      "ما أكثر مجاملة تحب تسمعها؟",
      "ما أكثر شيء يخليك تحس بالدلع؟",
      "ما النسخة الأجمل من ليلة خاصة في البيت؟",
    ],
  },
  {
    key: "challenges",
    label: "تحديات لطيفة",
    items: [
      "دقيقة كاملة بدون كلام، فقط قرب.",
      "رسالة حب من ثلاث جمل.",
      "حضن طويل.",
      "مجاملة صريحة.",
      "كل شخص يختار أغنية.",
      "اكتبوا موعدًا خاصًا في التقويم.",
      "قولوا ذكرى مضحكة.",
      "رتبوا جلسة بدون جوالات.",
      "اختاروا فيلمًا لليلة.",
      "كل شخص يحضر للآخر مشروبًا.",
      "قولوا «شكرًا» على شيء حقيقي.",
      "اسألوا سؤالًا لم تسألوه من قبل.",
      "اجلسوا قريبين 10 دقائق.",
      "اختاروا صورة قديمة وعلقوا عليها.",
      "اكتبوا عادة جديدة.",
    ],
  },
  {
    key: "agreement",
    label: "اتفاق جديد",
    items: [
      "ما الشيء الذي نريد نحافظ عليه؟",
      "ما العادة التي نوقفها؟",
      "ما العادة التي نبدأها؟",
      "ما وقتنا الأسبوعي؟",
      "كيف نحمي علاقتنا من الجوال؟",
      "كيف نعتذر أسرع؟",
      "كيف نختلف بدون قسوة؟",
      "ما الشيء الذي لا نسمح للروتين يأخذه؟",
      "ما معنى القرب بالنسبة لنا؟",
      "ما الوعد الواقعي لهذا الشهر؟",
      "ما الشيء الذي سنحتفل به؟",
      "ما الشيء الذي نحتاج نخففه؟",
      "ما الشيء الذي نريده أكثر؟",
      "كيف نجعل البيت أهدأ؟",
      "كيف نرجع كفريق؟",
    ],
  },
  {
    key: "newlyweds",
    label: "للعروسين",
    items: [
      "ما الشيء الذي تريد أعرفه عن يومك؟",
      "ما عادتك الصباحية؟",
      "كيف تحب ترتيب البيت؟",
      "ما الشيء الذي يضايقك بصمت؟",
      "كيف تحب أطلب منك شيئًا؟",
      "ما طريقة المزاح التي لا تحبها؟",
      "ما أول عادة نبنيها كزوجين؟",
      "ما الشيء الذي يجعلك تحس بالاستقرار؟",
      "ما الشيء الذي تخجل تقوله لكن تريدني أعرفه؟",
      "كيف نبدأ حياتنا بدون ضغط مثالية؟",
    ],
  },
  {
    key: "short_messages",
    label: "رسائل قصيرة",
    items: [
      "أفتقد جلسة هادئة معك.",
      "الليلة أبغى وقت لنا بس.",
      "وجودك يفرق حتى لو ما قلت.",
      "خلينا نطفي الجوالات شوي.",
      "أبغى نرجع نضحك مثل أول.",
      "أحب لما تكون قريب.",
      "تعال نسوي شيء بسيط ومختلف.",
      "الليلة لا مسؤوليات، بس نحن.",
      "أبغى أسمعك بدون مقاطعة.",
      "مشتاق/ة لإحساسنا القديم.",
      "أنت بيتي قبل البيت.",
      "خلينا نبدأ من جديد بهدوء.",
      "أحبك بس أحيانًا الأيام تغطينا.",
      "أحتاج قربك أكثر من كلام كثير.",
      "اليوم أبغى أختارك من جديد.",
      "خلينا نعمل لنا عادة حلوة.",
      "لا نترك الروتين يأخذنا.",
      "الليلة لنا.",
      "قربك يكفيني.",
      "أبغى بيننا يبقى حي.",
    ],
  },
];

// WhatsApp scripts — wife→husband, husband→wife, neutral
export const SCRIPTS = {
  wife: [
    "الليلة أبغى نسوي شيء بسيط لنا، بدون جوالات وبدون طلبات.",
    "مو محتاجة طلعة كبيرة، بس أبغى جلسة أحس فيها إننا قريبين.",
    "اشتقت لضحكتنا القديمة. الليلة نرجعها؟",
    "خلينا نخلي اليوم لنا شوي.",
    "أبغى أقول لك أشياء حلوة بس بطريقة مختلفة.",
  ],
  husband: [
    "الليلة أبغى وقت لنا، لا مسؤوليات ولا جوالات.",
    "أعرف أن الأيام أخذتنا، بس أبغى أرجع أقرب لك.",
    "جهزي نفسك لجلسة بسيطة، الباقي علي.",
    "أبغى أسمعك اليوم بدون استعجال.",
    "خلينا نسوي ليلة مختلفة في البيت.",
  ],
  neutral: [
    "اليوم نحتاج نطفي العالم شوي.",
    "مو لازم نطلع. بس نحتاج نكون مع بعض فعلًا.",
    "خلينا نجرب أول ليلة من البرنامج.",
    "نص ساعة لنا بدون أي شيء ثاني.",
    "اشتقت لنا.",
  ],
};

// 10 home night ideas + monthly continuation plan
export const HOME_NIGHTS = [
  "ليلة قهوة وذكريات",
  "ليلة فيلم ورسالة قبل النوم",
  "ليلة طبخة مشتركة",
  "ليلة صور قديمة",
  "ليلة بدون جوالات",
  "ليلة أسئلة عميقة",
  "ليلة دلع بسيط",
  "ليلة موسيقى هادئة",
  "ليلة تخطيط سفر",
  "ليلة اتفاق جديد",
];

export const MONTHLY = [
  { week: "الأسبوع 1", focus: "جلسة ضحك وأسئلة خفيفة" },
  { week: "الأسبوع 2", focus: "جلسة تقدير وامتنان" },
  { week: "الأسبوع 3", focus: "ليلة خاصة بدون جوالات" },
  { week: "الأسبوع 4", focus: "اتفاق وتجديد عادة" },
];
